import Vue from 'vue'

const actions = {
  setEvents: (context, payload) => {
    context.commit('SET_EVENTS', payload)
  },
}
const getters = {
  getEvents: state => state.events,
}
const mutations = {
  SET_EVENTS: (state, payload) => {
    Vue.set(state, 'events', payload)
  },
}
const state = {
  events: [],
}

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
}
